import { mergeSxProps } from "../../lib/mergeSxProps";
import { Slider, type SliderProps } from "../Slider";

interface DistanceSliderProps extends Pick<
  SliderProps,
  | "defaultValue"
  | "sx"
  | "min"
  | "max"
  | "disabled"
  | "onChange"
  | "step"
  | "value"
  | "valueLabelDisplay"
> {
  options: number[];
}

export function DistanceSlider(props: DistanceSliderProps) {
  const { options, sx, ...rest } = props;

  const marks = options.map((value) => ({
    value,
    label: `${value}mi`,
  }));

  const min = Math.min(...options);
  const max = Math.max(...options);

  return (
    <Slider
      thumb
      marks={marks}
      variant="circular"
      color="primary"
      min={min}
      max={max}
      valueLabelFormat={(value) => `${value}mi`}
      {...rest}
      sx={mergeSxProps(
        (theme) => ({
          width: "auto",
          height: "0.5rem",
          padding: "1rem",

          // compensate for mark labels which uses position absolute
          // and is below the slider
          marginBottom: "2rem",

          ".MuiSlider-markLabel": {
            marginTop: "0.3rem",
          },

          "& .MuiSlider-rail": {
            height: "0.5rem",
            color: theme.palette.background?.primary,
          },

          "& .MuiSlider-thumb": {
            display: "flex",
            // color: theme.palette.border?.main,
            backgroundColor: theme.palette.background.tertiary,
            border: `1px solid ${theme.palette.primary?.main}`,
            height: "1.5rem",
            width: "1.5rem",

            backgroundImage: `url("data:image/svg+xml,${encodeURIComponent(
              `<svg xmlns='http://www.w3.org/2000/svg' width='8.5' height='10'>
                       <rect x='0' y='1' width='1' height='8' fill='${theme.palette.primary?.main}'/>
                       <rect x='3.5' y='0' width='1' height='12' fill='${theme.palette.primary?.main}'/>
                       <rect x='7' y='1' width='1' height='8' fill='${theme.palette.primary?.main}'/>
                     </svg>`
            )}")`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",

            "&:hover, &.Mui-focusVisible": {
              boxShadow: `0px 0px 0px 1px ${theme.palette.primary?.main}`,
            },
            "&.Mui-active": {
              boxShadow: `0px 0px 0px 2px ${theme.palette.primary?.main}`,
            },
          },
        }),
        sx
      )}
    />
  );
}
